var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page home-page scrollbar-style" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "grid" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("div", { staticClass: "cell-sm-12 cell-md-6 cell-lg-3" }, [
              _c(
                "div",
                {
                  staticClass: "card image-header",
                  staticStyle: { border: "none" }
                },
                [
                  _c("div", {
                    staticClass: "card-header fg-white bg-black",
                    staticStyle: { "background-size": "cover", border: "none" },
                    style: { "background-image": _vm.bioImageUrl }
                  }),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "card-footer fg-white bg-black",
                      staticStyle: {
                        border: "none",
                        "flex-direction": "row-reverse"
                      }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "button outline right fg-white",
                          staticStyle: {
                            border: "none",
                            "font-weight": "bold"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onViewArt()
                            }
                          }
                        },
                        [_vm._v("Read more")]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm._l(_vm.items, function(a, idx) {
              return _c(
                "div",
                { key: idx, staticClass: "cell-sm-12 cell-md-6 cell-lg-3" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card image-header",
                      staticStyle: { border: "none" }
                    },
                    [
                      _c("div", {
                        staticClass: "card-header fg-white bg-black",
                        staticStyle: {
                          "background-size": "cover",
                          border: "none"
                        },
                        style: {
                          "background-image": _vm.randomize(a.imageUrls)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "card-content p-2 fg-white bg-black",
                          staticStyle: { height: "200px", overflow: "hidden" }
                        },
                        [
                          _c("strong", [_vm._v(_vm._s(a.title))]),
                          _vm._v(" "),
                          _c("br"),
                          _c("br"),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm._f("limitCharacters")(a.description)) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "card-footer fg-white bg-black",
                          staticStyle: {
                            border: "none",
                            "flex-direction": "row-reverse"
                          }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "button outline fg-white",
                              staticStyle: {
                                border: "none",
                                "font-weight": "bold"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onViewArt(a)
                                }
                              }
                            },
                            [_vm._v("View art")]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            })
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _vm.selectedItem && _vm.showBio
      ? _c(
          "div",
          {
            staticStyle: {
              position: "fixed",
              top: "0px",
              bottom: "0px",
              left: "0px",
              right: "0px",
              width: "100%",
              height: "100%",
              "z-index": "1000",
              "background-color": "rgba(0,0,0,0.7)"
            }
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  margin: "20px auto",
                  width: "80%",
                  height: "90%",
                  "background-color": "#000",
                  border: "1px solid #666",
                  padding: "20px"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: { display: "flex", "flex-direction": "column" }
                  },
                  [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            flex: "1 1 auto",
                            "font-weight": "bold"
                          }
                        },
                        [
                          _vm._v(
                            "\n                        Γιώργος Γκιζάρης\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            flex: "0 0 40px",
                            "text-align": "center"
                          }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "button outline fg-white",
                              staticStyle: {
                                border: "none",
                                "font-weight": "bold",
                                cursor: "pointer"
                              },
                              on: {
                                click: function() {
                                  this$1.showBio = false
                                }
                              }
                            },
                            [_vm._v("X")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { color: "#aaa", "font-size": "16px" } },
                      [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("p", [
                          _c("img", {
                            staticStyle: {
                              width: "200px",
                              float: "left",
                              "margin-right": "10px"
                            },
                            attrs: {
                              src: _vm.bioImageUrl
                                .replace("url(", "")
                                .replace(")", "")
                            }
                          }),
                          _vm._v(
                            "\n                        Απόφοιτος Γαλλικής Φιλολογίας και Οπτικοακουστικών Μέσων του πανεπιστημίου Paris VIII-Vincennes. Παρακολούθησε επίσης μαθήματα υποκριτικής στο Θεατρικό εργαστήρι του Βασίλη Διαμαντόπουλου, πιάνου και μονωδίας στο Ελληνικό Ωδείο. Σπούδασε καλλιτεχνική φωτογραφία και τεχνικές σκοτεινού θαλάμου στον Πειραϊκό Σύνδεσμο και στο Φωτογραφικό Κέντρο του Δήμου Ζωγράφου. Έχει πραγματοποιήσει δέκα ατομικές εκθέσεις και συμμετάσχει σε τριάντα τρεις ομαδικές καθώς και σε πολιτιστικά δρώμενα όπως φεστιβάλ και καλλιτεχνικές διοργανώσεις κερδίζοντας βραβεία και διακρίσεις σε πανελλήνιους φωτογραφικούς διαγωνισμούς. Μεγάλο μέρος της δουλειάς του έχει δημοσιευτεί σε φωτογραφικά περιοδικά. Είναι ιδρυτικό μέλος της φωτογραφικής ομάδας ΦΩΣ (1998) και Φ.Π.Κ.Π (Φωτογραφικό Πολιτιστικό Κέντρο Πειραιά, 2001). Τακτικό μέλος της Ε.Φ.Ε (Ελληνική Φωτογραφική Εταιρία) και του Φ.Κ.Θ (Φωτογραφικό Κέντρο Θεσσαλονίκης). Μέλος του Εικαστικού Επιμελητηρίου Ελλάδος.\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                        He graduated in Lettres et Arts and Audiovisuals at University Paris VIII-Vincennes. He attended lessons in the Theatrical Studio of Vassilis Diamandopoulos, and in the Hellenic Conservatory of Music. He studied artistic photography and its techniques in the Association of Piraeus and in the photographic department of Municipality of Zografos. He performed ten individual exhibitions and he also took part in thirty three collective ones. He participated in many cultural events, such as festivals and performances and a great part of his work has been published in Greek photographic magazines. He won some prizes as well as distinctions in international photographic competitions. He is one of the founding members of the teams ΦΩΣ (1998) and Φ.Π.Κ.Π (Photographic Cultural Center of Piraeus,2001). Regular member of Ε.Φ.Ε (Hellenic Association of Photographers) and Φ.Κ.Θ (Thessaloniki Photography Center). Member of the Greek Chamber of the Fine Arts.\n                    "
                          )
                        ])
                      ]
                    )
                  ]
                )
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "cell-sm-full cell-md-10" }, [
        _c("h3", [_vm._v("Γιώργος Γκιζάρης")]),
        _vm._v(" "),
        _c("h5", [_vm._v("Φωτογραφία")])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cell-sm-full cell-md-2",
          staticStyle: { "font-size": "12px" }
        },
        [
          _c("div", [_c("strong", [_vm._v("Τηλ:")]), _vm._v("  6976359583")]),
          _vm._v(" "),
          _c("div", [
            _c("strong", [_vm._v("Email:")]),
            _vm._v("  gguizaris@hotmail.com")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card-content p-2 fg-white bg-black",
        staticStyle: { height: "200px", overflow: "hidden" }
      },
      [
        _c("strong", [_vm._v("Βιογραφικό")]),
        _vm._v(" "),
        _c("br"),
        _c("br"),
        _vm._v(
          "\n                        \n                        Απόφοιτος Γαλλικής Φιλολογίας και Οπτικοακουστικών Μέσων του πανεπιστημίου Paris VIII-Vincennes. Παρακολούθησε επίσης \n                        μαθήματα υποκριτικής στο Θεατρικό εργαστήρι του Βασίλη Διαμαντόπουλου, πιάνου και μονωδίας στο Ελληνικό Ωδείο (...)\n                    "
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("Βιογραφικό")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }